import { render, staticRenderFns } from "./ApiCallDetail.vue?vue&type=template&id=06d74ef5&"
import script from "./ApiCallDetail.vue?vue&type=script&lang=js&"
export * from "./ApiCallDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports